import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Hero from './components/Hero';
import TrustBar from './components/TrustBar';
import StatsBar from './components/StatsBar';
import WhatWeDo from './components/WhatWeDo';
import WhyAgents from './components/WhyAgents';
import HowItWorks from './components/HowItWorks';
import UseCases from './components/UseCases';
import Founder from './components/Founder';
import FAQ from './components/FAQ';
import Contact from './components/Contact';
import Footer from './components/Footer';

export default function HomePage() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [showScrollTop, setShowScrollTop] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
      setShowScrollTop(window.scrollY > 400);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    if (menuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => { document.body.style.overflow = ''; };
  }, [menuOpen]);

  const navLinks = [
    { label: 'How It Works', href: '#how-it-works' },
    { label: 'Use Cases', href: '#use-cases' },
    { label: 'About', href: '#about' },
  ];

  return (
    <div className="min-h-screen bg-white">
      <nav
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 bg-black ${
          scrolled || menuOpen
            ? 'shadow-[0_1px_20px_rgba(0,0,0,0.3)]'
            : ''
        }`}
      >
        <div className="max-w-[1400px] mx-auto px-5 md:px-8 py-4 md:py-5 flex items-center justify-between">
          <div className="flex items-center">
            <img
              src="https://static.readdy.ai/image/39cbf484d561e1f62e3c6532cd56d730/5b0e55db21655eca8e03e44a17fcce4c.png"
              alt="EasyMarketPro"
              className="h-10 md:h-14 w-auto"
            />
            <span className="ml-2 text-[18px] md:text-[22px] font-bold text-[#B8985F] tracking-tight">EasyMarketPro</span>
          </div>

          <div className="hidden md:flex items-center gap-12">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                className="text-[15px] font-medium transition-colors cursor-pointer text-[#E5E5E5] hover:text-[#B8985F]"
              >
                {link.label}
              </a>
            ))}
            <Link
              to="/book-a-call"
              className="px-8 py-3 bg-[#B8985F] text-white rounded-md font-medium hover:bg-[#A68850] transition-all cursor-pointer whitespace-nowrap"
            >
              Book a Call
            </Link>
          </div>

          <button
            onClick={() => setMenuOpen(!menuOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center cursor-pointer"
            aria-label="Toggle menu"
          >
            <i className={`${menuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl text-white`}></i>
          </button>
        </div>

        {menuOpen && (
          <div className="md:hidden bg-black border-t border-[#333] px-5 pb-6 pt-4 space-y-1">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setMenuOpen(false)}
                className="block py-3 text-[15px] font-medium text-[#E5E5E5] hover:text-[#B8985F] transition-colors cursor-pointer"
              >
                {link.label}
              </a>
            ))}
            <Link
              to="/book-a-call"
              onClick={() => setMenuOpen(false)}
              className="block mt-3 text-center px-8 py-3 bg-[#B8985F] text-white rounded-md font-medium hover:bg-[#A68850] transition-all cursor-pointer whitespace-nowrap"
            >
              Book a Call
            </Link>
          </div>
        )}
      </nav>

      <Hero />
      <TrustBar />
      <StatsBar />
      <WhatWeDo />
      <WhyAgents />
      <HowItWorks />
      <UseCases />
      <Founder />
      <FAQ />
      <Contact />
      <Footer />

      {/* Scroll to top button — bottom left, clear of Botpress chatbot */}
      <button
        onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
        className={`fixed bottom-6 left-6 z-40 w-11 h-11 flex items-center justify-center rounded-full bg-[#B8985F] text-white shadow-lg hover:bg-[#A68850] transition-all duration-300 cursor-pointer ${
          showScrollTop
            ? 'opacity-100 translate-y-0'
            : 'opacity-0 translate-y-4 pointer-events-none'
        }`}
        aria-label="Scroll to top"
      >
        <i className="ri-arrow-up-line text-lg"></i>
      </button>
    </div>
  );
}
